/**
 * @desc SKU-导出采购信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productSku.exportExcelPurchaseInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/exportExcelPurchaseInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
